module.exports = __webpack_public_path__ + "img/icon_activity_history.bebba08.svg";